import { Attr, Model } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

/**
 * The current T&Cs version metadata.
 *
 * Django is the authority for the *version* only - it never serves the T&Cs
 * text. The body lives in WordPress, at `sourceUrl`; see TermsDialog.vue.
 *
 * Unauthenticated, so it is available at registration time before login.
 */
@Model()
export default class Terms extends ApplicationRecord {
  static jsonapiType = 'terms';

  /**
   * The single current record.
   *
   * The list endpoint is paginated and always returns exactly one row, so this
   * takes the first rather than assuming a bare object.
   */
  static async current(): Promise<Terms | null> {
    const { data } = await Terms.all();
    return data.length ? data[0] : null;
  }

  @Attr() version: string;

  @Attr() contentHash: string;

  @Attr() sourceUrl: string;

  @Attr() updatedAt: string;
}
